import { useProjectContext } from "@contexts/projects";

export const isBuildingTrial = () => {

  const { activeProject } = useProjectContext()

  return activeProject?.building_level === 'trial'
}